// WhatsAppButton.js
import React from 'react';
import whatsapp from '../assets/Gallery/whats-app-icon.webp';
import '../assets/css/Whatsapp.css';

const Whatsapp = () => {
    const phoneNumber = '919730610099'; // your number
    const message = encodeURIComponent(
        'Hi, I visited Samriddhi Gurukul Website and want more details. Please connect.'
    );

    return (

        <div className='whatsapp-container'>

            <div className="whats-app">
                <a
                    href={`https://wa.me/${phoneNumber}?text=${message}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="whatsapp-button"
                >
                    <img src={whatsapp} loading="lazy" alt="WhatsApp" className="whatsapp-icon" />
                    <div className="whatsapp-text">
                        <strong>Whatsapp</strong> <br />
                        <span>click to chat</span>
                    </div>
                </a>

            </div>
        </div>




    );
};

export default Whatsapp;
